import {
    DndContext, closestCorners,
    KeyboardSensor,
    PointerSensor, useSensor, useSensors,
    DragOverlay
} from "@dnd-kit/core";

import { MyItem } from "./SortItem";
import MyContainerNumbered from "./SortContainerNumbered";
import { useState } from "react";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import MyContainer from "./SortContainer";


export default function DragAndDrop({ allItems, setAllItems }) {
    const [activeId, setActiveId] = useState(null);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    function handleDragStart(event) {
        const { active } = event;

        setActiveId(active.id);
    }

    function findContainer(id) {
        if (id in allItems) {
            return id;
        }

        return Object.keys(allItems).find((key) => allItems[key].includes(id));
    }

    function handleDragEnd(event) {
        const { active, over } = event;
        const { id } = active;
        const { id: overId } = over;

        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);

        if (
            !activeContainer ||
            !overContainer ||
            activeContainer !== overContainer
        ) {
            return;
        }

        const activeIndex = allItems[activeContainer].indexOf(active.id);
        const overIndex = allItems[overContainer].indexOf(overId);

        if (activeIndex !== overIndex) {
            setAllItems((allItems) => ({
                ...allItems,
                [overContainer]: arrayMove(allItems[overContainer], activeIndex, overIndex)
            }));
        }

        setActiveId(null);
    }

    function handleDragOver(event) {
        console.log("event: ", event);
        const { active, over } = event;
        // const { active, over, draggingRect } = event;
        const { id } = active;
        const { id: overId } = over;

        // Find the containers
        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);

        if (
            !activeContainer ||
            !overContainer ||
            activeContainer === overContainer
        ) {
            return;
        }

        setAllItems((prev) => {
            const activeItems = prev[activeContainer];
            const overItems = prev[overContainer];

            // Find the indexes for the items
            const activeIndex = activeItems.indexOf(id);
            const overIndex = overItems.indexOf(overId);

            let newIndex;
            if (overId in prev) {
                // We're at the root droppable of a container
                newIndex = overItems.length + 1;
            } else {
                const isBelowLastItem =
                    over &&
                    overIndex === overItems.length - 1
                // wofür auch immer das notwendig wäre...: &&
                // draggingRect.offsetTop > over.rect.offsetTop + over.rect.height;

                const modifier = isBelowLastItem ? 1 : 0;

                newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
            }

            return {
                ...prev,
                [activeContainer]: [
                    ...prev[activeContainer].filter((item) => item !== active.id)
                ],
                [overContainer]: [
                    ...prev[overContainer].slice(0, newIndex),
                    allItems[activeContainer][activeIndex],
                    ...prev[overContainer].slice(newIndex, prev[overContainer].length)
                ]
            };
        });
    }


    return (
        <section style={{ 'display': 'flex', flexDirection: "row" }}>
            {/* https://codesandbox.io/p/sandbox/dnd-kit-multi-containers-lknfe?file=%2Fsrc%2Fapp.js%3A100%2C12 */}
            <DndContext
                sensors={sensors}
                collisionDetection={closestCorners}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
            >
                <MyContainerNumbered id="base" items={allItems.base} which="Gewählte Strecke" />
                <MyContainer id="extra" items={allItems.extra} which="Weitere Bahnhöfe" />
                <MyContainer id="del" items={allItems.del} which="Entfernte Bahnhöfe" />
                <DragOverlay>
                    {activeId ? <MyItem id={activeId} /> : null}
                </DragOverlay>
            </DndContext>
        </section>
    );
}